import React from 'react';
import classNames from "classnames";

import Switch from '../../../../../general-ui/switch/switch';
import { useTranslate } from "../../../../../../i18n/useTranslationModules";
import { Session, SessionPreview } from "../../../../../../types/working-model";
import { noTrackName } from '../../../../../live-event/modules/agenda/agenda-utils';

interface CarouselGroupDropdownProps {
	groupTitle: string;
	isOpen: boolean;
	onExpand: () => void;
	contentGroup: { [key: string]: (Session | SessionPreview)[]; };
	contentGroupDisplayOrder: string[];
	generateCarousel: (track: string, group: (Session | SessionPreview)[]) => JSX.Element;
	onGroupToggle: (value: string, on: boolean) => void;
	groupToggleValue?: boolean;
	groupControls?: () => React.ReactNode;
	resultsFiltered: boolean;
}

const CarouselGroupDropdown: React.FC<CarouselGroupDropdownProps> = (
	({
		groupTitle,
		isOpen,
		onExpand,
		onGroupToggle,
		groupToggleValue = false,
		contentGroup,
		contentGroupDisplayOrder,
		generateCarousel,
		groupControls,
		resultsFiltered = false,
	}) => {
		const { t } = useTranslate('homepage');

		const key = `cg-${groupTitle.replaceAll(' ', '')}`;

		const renderUncategorized = () => {
			return Object.keys(contentGroup).length > 0
				? contentGroupDisplayOrder.map(track => {
					if (!contentGroup[track]) return;
					if (track !== noTrackName) return;
					return (
						<React.Fragment key={track}>
							{generateCarousel(t(track, track), contentGroup[track])}
						</React.Fragment>
					);
				})
				: <div className='empty-track'>{
					resultsFiltered
						? 'No sessions match your search'
						: `No ${groupTitle} to show`
				}</div>;
		};

		const renderCategorized = () => {
			return Object.keys(contentGroup).length > 0
				? contentGroupDisplayOrder.map(track => {
					if (!contentGroup[track]) return;
					if (track === noTrackName) return;
					return (
						<React.Fragment key={track}>
							{generateCarousel(t(track, track), contentGroup[track])}
						</React.Fragment>
					);
				})
				: <div className='empty-track'>{
					resultsFiltered
						? 'No sessions match your search'
						: `No ${groupTitle} to show`
				}</div>;
		};

		return (
			<div key={key} className={'agenda-sessions-section carousel-main-manage-content '}>
				<div className="track-controls">
					<div className="group-title">
						<Switch
							value={`enable-group`}
							on={groupToggleValue}
							onClick={onGroupToggle}
							disabled={Object.keys(contentGroup).length <= 0}
						/>
						<h4>{t(groupTitle, groupTitle)}</h4>
					</div>

					<div className="col-right">

						{Object.keys(contentGroup).length > 0 &&
							<div className="expand-dropdown">
								{groupControls && <div className="custom-header">{groupControls()}</div>}
								<div className={classNames('new-dropdown-icon', { 'isopen': isOpen, 'isnotexpanded': !isOpen })} onClick={onExpand}></div>
							</div>
						}

					</div>
				</div>
				{renderUncategorized()}
				{renderCategorized()}
			</div>
		);
	});


export default CarouselGroupDropdown;